import { Button } from 'reactstrap';
import styled from 'styled-components';
import { color } from '~/assets/styles/colors';

export const DivMobile = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 10px;
	border-radius: 0px 0px 30px 30px;
	background-color: ${color.primary};
	h3{
		font-size: 16px;
		font-weight: bold;
	}
`;

export const DivInfo = styled.div`
	display: flex;
	width: 100%;
	justify-content: space-between;

	p{
		font-size: 36px;
		font-weight: bolder;
	}
`;


export const Container = styled.div`
	width: 100%;
	padding: 0px !important;
	margin: 0px !important;
`;


export const ButtonMobile = styled(Button)`
	padding: 0px;
	margin: 0px  0px 10px 0px ;
	background-color: ${color.primary};
	border: none;

	&:hover,
	&:focus{
		background-color: ${color.primary} !important;
		border: none !important;
	}

	&:disabled{
		background-color: ${color.primary} !important;
		color: ${color.grayDark};
	}
`;
